import { addDisplayName, flowMax } from 'ad-hok'
import { addEffectOnMount } from 'ad-hok-utils'
import { FC } from 'react'
import { addApi, addUser } from 'shared/src/api'

import { Account } from '../account/index'

interface Props {
  onFinish: () => void
}

export const Onboarding: FC<Props> = flowMax(
  addDisplayName('Onboarding'),
  addApi,
  addUser,
  addEffectOnMount(({ user, api }) => () => {
    if (!user.onboardingStartedAt) {
      api.users
        .startOnboarding()
        .catch((error) =>
          console.error('Error recording onboarding start', error)
        )
    }
  }),
  ({ onFinish }) => <Account firstStep="user" onOnboardingFinished={onFinish} />
)
